<template>
    <div id="page" class="page">

        <interne_menu></interne_menu>
               
        <!-- Mentions legales -->
        <section id="faqs-1" class="bg-fixed bg-lightgrey wide-60 faqs-section division contact-bck">						
            <div class="container">


                <!-- SECTION TITLE -->	
                <div class="row">	
                    <div class="col-md-10 offset-md-1 section-title">	

                        <!-- Title 	-->	
                        <h2 class="h2-lg">Mention Légales & Conditions d’utilisation du site</h2>	

                        <!-- Text -->
                        <p>Ce site est publié par Weblogy offshore, SARL au capital de<br> 1 000 000 FCFA, BP 652 Grand-Bassam, Cote d’Ivoire.</p>
                                
                    </div> 	 <!-- End row --> 	
                </div>	 <!-- END SECTION TITLE -->	

                <div class="row">
<!-- QUESTIONS HOLDER -->
<div class="col-lg-12">
                        <div class="questions-holder ind-30">


                            <!-- QUESTION #1 -->
                            <div class="question animated fadeInUp visible" data-animation="fadeInUp" data-animation-delay="300">

                                <!-- Question -->
                                <h5 class="h5-sm">Conditions d’utilisation du site</h5>

                                <!-- Answer -->
                                <p>En accédant au présent site internet (« le Site ») et aux informations qu’il contient, l’internaute (ci-après désigné l’« Utilisateur »), 
                                    reconnaît avoir pris connaissance des présentes conditions d’utilisation du Site (les « CGU »), et s’engage à s’y conformer.</p>
                                <p>Weblogy offshore se réserve le droit de modifier les présentes CGU à tout moment afin, notamment, de les adapter aux évolutions du Site.
                                     L’Utilisateur s’engage ainsi à les consulter régulièrement et est réputé leur dernière version à chaque nouvelle connexion au Site.</p>
                            </div>	                        

                        </div>
                    </div>	<!-- END QUESTIONS HOLDER -->

                </div>


                <div class="row">
                    
                    <!-- QUESTIONS HOLDER -->
                    <div class="col-lg-6">
                        <div class="questions-holder ind-30">


                            <!-- QUESTION #5 -->
                            <div class="question animated fadeInUp visible" data-animation="fadeInUp" data-animation-delay="300">

                                <!-- Question -->
                                <h5 class="h5-sm">Présentation du Site</h5>

                                <!-- Answer -->
                                <p>Le Site est un site d’information et de présentation à destination du public – clients et non clients de weblogy offshore – de l’activité et des services fournis par weblogy offshore.</p>

                            </div>	

                            <!-- QUESTION #6 -->
                            <div class="question animated fadeInUp visible" data-animation="fadeInUp" data-animation-delay="500">

                                <!-- Question -->
                                <h5 class="h5-sm">Accès au Site</h5>

                                <!-- Answer -->
                                <p>L’utilisateur du Site reconnaît disposer de la compétence et des moyens nécessaires pour accéder et utiliser ce Site. L’accès au Site est gratuit et est possible 24H/24 et 7J/7,
                                     sous réserve des opérations de contrôle ou de maintenance nécessaires au bon fonctionnement du Site.</p>
                                
                                <p>weblogy offshore s’engage à mettre en œuvre les moyens nécessaires pour assurer la disponibilité du Site dans des conditions optimales,
                                     mais ne peut en aucun cas garantir un fonctionnement ininterrompu du Site.</p>

                                 <p>Les équipements (ordinateur, téléphone mobile, logiciels, moyens de télécommunication, etc.) permettant l’accès au Site sont à la charge de l’Utilisateur, de même que les frais de
                                     télécommunications induits par leur utilisation. Weblogy offshore se réserve le droit de supprimer, modifier, corriger et compléter à tout moment et sans préavis 
                                     les fonctionnalités et services fournis sur le Site ainsi que de désactiver le Site sans préavis ou de suspendre temporairement le Site.</p>

                            </div>


                            <!-- QUESTION #7 -->
                            <div class="question animated fadeInUp visible" data-animation="fadeInUp" data-animation-delay="600">

                                <!-- Question -->
                                <h5 class="h5-sm">Propriété intellectuelle</h5>

                                <!-- Answer -->
                                <p>Weblogy offshore est seul titulaire des droits attachés aux noms, marques, noms de domaines, logos ou autres signes distinctifs respectifs du Site.Weblogy offshore accorde à l’Utilisateur
                                     uniquement un droit d’utilisation et de consultation des informations figurant sur le Site et pour un usage strictement personnel.
                                </p>

                                <p>Tout autre exploitation du Site et des données y afférentes par l’Utilisateur, sans autorisation expresse et préalable de Weblogy offshore, est interdite et constituerait une contrefaçon 
                                    sanctionnée par les articles ... et suivants du Code de la Propriété Intellectuelle.
                                </p>

                                

                            </div>	


                        </div>
                    </div>	<!-- END  QUESTIONS HOLDER -->

                    <!-- QUESTIONS HOLDER -->
                    <div class="col-lg-6">
                        <div class="questions-holder ind-30">


                            <!-- QUESTION #1 -->
                            <div class="question animated fadeInUp visible" data-animation="fadeInUp" data-animation-delay="300">

                                <!-- Question -->
                                <h5 class="h5-sm">Responsabilité</h5>

                                <!-- Answer -->
                                <p>Weblogy offshore se réserve le droit de corriger, à tout moment et sans préavis, le contenu du Site. D’une façon générale, l’Utilisateur s’engage à respecter l’intégrité du Site
                                     et s’interdit d’entraver ou forcer le fonctionnement du Site, de modifier, d’altérer ou de supprimer frauduleusement les contenus accessibles via le Site et d’introduire 
                                     frauduleusement des données sur le Site.
                                </p>
                                <p>Ainsi, Weblogy offshore ne saurait être tenue responsable :<br>des éléments en dehors de son contrôle et des dommages qui pourraient éventuellement être subis par l’Utilisateur
                                     et son environnement technique, notamment ses ordinateurs, logiciels, équipements réseaux utilisés pour accéder ou utiliser le Site; en cas de difficultés rencontrées par 
                                     l’Utilisateur lors de l’accès au Site, en cas de perturbation ou d’interruption du Site, pour quelque cause que ce soit ; en cas d’erreur ou d’omission quant
                                      au contenu des présentes pages et de toute décision prise sur la base d’une information contenue sur le Site, en dehors de celle présente dans les conditions
                                       générales des services et la politique de confidentialité.
                                </p>

                            </div>	


                            <!-- QUESTION #2 -->					
                            <div class="question animated fadeInUp visible" data-animation="fadeInUp" data-animation-delay="400">

                                <!-- Question -->
                                <h5 class="h5-sm">Liens hypertextes</h5>

                                <!-- Answer -->
                                <p>Les Utilisateurs ne peuvent pas mettre en place de liens hypertextes en direction du Site sans l’autorisation expresse et préalable de Paylib Services SAS. L’existence,
                                     sur le présent Site, d’un lien hypertexte conduisant à un autre site ne constitue pas une validation de cet autre site ou de son contenu.
                                </p>

                            </div>

                                    
                            <!-- QUESTION #3 -->
                            <div class="question animated fadeInUp visible" data-animation="fadeInUp" data-animation-delay="500">

                                <!-- Question -->
                                <h5 class="h5-sm">Loi applicable</h5>

                                <!-- Answer -->
                                <p>Les présentes CGU seront interprétées conformément à la loi ivoirienne.</p>									

                            </div>	


                            <!-- QUESTION #4 -->
                            <div class="question animated fadeInUp visible" data-animation="fadeInUp" data-animation-delay="600">

                                <!-- Question -->
                                <h5 class="h5-sm">Contact</h5>

                                <!-- Answer -->
                                <p>Toute question relative à l’Application et/ou aux services fournis par Weblogy Offshore doit être adressée à : <a href="mailto:apaym@weblogy.com">apaym@weblogy.com</a>
                                </p>

                            </div>


                        </div>
                    </div>	<!-- END QUESTIONS HOLDER -->


                </div>	<!-- End row -->		



            </div>	   <!-- End container -->		
			</section>
        <!-- Mentions legales -->

       

        <footer_menu></footer_menu>
    </div>

</template>

<script>
import interne_menu  from '../components/interne_menu.vue';
import footer_menu  from '../components/footer_menu.vue';
export default{
    name :'nos_cartes',
    components:{
      'interne_menu' :interne_menu,
      'footer_menu' :footer_menu
    } 
}


</script>

<style scoped>
.pro_part{
    background: url(@/assets/images/pic-pro-interne.png) no-repeat;   
}
.sct_bck{
    background: url(@/assets/images/95b26da8.png) no-repeat;   
}
.wide-60 {
    padding-top: 190px;
    padding-bottom: 60px;
}
.btn-lightorange {
    color: #fff;
    background-color: #ff9e00;
    border-color: #f3a72e;
}
#download-2 .bg-inner {
    /* background-image: url(../images/download-2.jpg); */
    position: relative;
    z-index: 1;
    background: #261b64;
}
.orange{
color: #ff9e00;
}
.h5-sm{
    color: #261b64;
}

</style>

